import { Blog } from 'src/types';
import ImageWithFallback from 'src/components/ImageWithFallback';
import { AppRoutes } from 'src/lib/routes';

type Props = {
  blog: Blog;
};

const BlogEmbedCard: React.FC<Props> = ({ blog }) => {
  return (
    <a
      href={AppRoutes.shortMagazineRoute({ id: blog.slug }).toPath()}
      className="md:tw-flex tw-my-8 md:tw-my-10"
      style={{ backgroundImage: 'none' }}
    >
      <ImageWithFallback
        src={blog.coverImgUrl}
        alt=""
        fill
        className="tw-static tw-block md:tw-w-72 tw-h-48 md:tw-h-52 tw-w-full tw-rounded-2xl tw-mb-2.5 md:tw-mb-0 tw-object-cover"
      />
      <div className="md:tw-ml-8">
        <div className="tw-text-sm tw-text-grey tw-pb-1.5 md:tw-pb-2 tw-border-b tw-border-grey-lighter tw-mb-4 tw-leading-none">
          Feeling inspired?
        </div>
        <div className="tw-text-lg tw-font-semibold tw-font-styleSans tw-text-brand-navy tw-mb-4">{blog.title}</div>
        <a href={AppRoutes.shortMagazineRoute({ id: blog.slug }).toPath()} className="btn btn-secondary">Explore More</a>
      </div>
    </a>
  );
};

export default BlogEmbedCard;
